import { getDefaultClient } from '@dynamic-labs-sdk/client/core';

import { addEIP6963Extension } from '../eip6963/addEIP6963Extension';
import { addWaasEvmExtension } from '../waas/addWaasEvmExtension';

/**
 * Adds the EVM extension to the Dynamic client.
 *
 * This is a convenience function that adds both the EIP-6963 extension
 * and the Dynamic WaaS EVM extension, enabling support for all EVM wallet types
 * including standard wallets and embedded wallets managed by Dynamic's infrastructure.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 */
export const addEvmExtension = (client = getDefaultClient()): void => {
  addEIP6963Extension(client);
  addWaasEvmExtension(client);
};
